export default __webpack_public_path__ + "static/media/Logo-LSP-GPPB.b30d3b4a.png";